module.exports = __webpack_public_path__ + "static/media/ico-events.27b80e15.svg";